/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DVideoPlayerContainer from '../video-player/video-player-container';
import styles from './content-item-row-media.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The video content in row content item with media.
 *
 * @element c4d-content-item-row-media-video
 */
@customElement(`${c4dPrefix}-content-item-row-media-video`)
class C4DContentItemRowMediaVideo extends C4DVideoPlayerContainer {
  /**
   * The shadow slot this video should be in.
   */
  @property({ reflect: true })
  slot = 'media';

  render() {
    return html` <slot></slot> `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--content-item-row-media-video`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentItemRowMediaVideo;
